var _rect, _path, _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgEpocratesPlusTickIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#06162D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6415 18.5215V24.2874H39.3596V26.2915L33.6415 26.2878V30.3176C33.6415 30.3184 33.6413 30.3194 33.6411 30.3205C33.6408 30.3218 33.6406 30.3233 33.6406 30.3248V30.3969C33.6406 31.3106 32.8703 32.0502 31.9206 32.0502H31.9134H31.5653H31.5581H31.5499V26.2896H25.8309V24.2874H31.5499V20.1945C31.5499 19.271 32.3292 18.5215 33.2906 18.5215H33.2933H33.4683H33.6397H33.6406H33.6415ZM8.63965 33.5702C8.63965 28.0315 12.636 24.0911 17.9068 24.0911C22.898 24.0911 26.6165 27.9729 26.6779 33.4538C26.6779 33.7857 26.6571 34.0978 26.6373 34.3711H10.9467C11.2831 38.6434 14.346 41.1002 18.1855 41.1002C20.7911 41.1002 22.8583 40.0874 24.5097 38.4856L25.7218 40.008C23.3561 42.3683 20.7496 43.0312 18.0457 43.0312C12.5765 43.0312 8.63965 39.1692 8.63965 33.5702ZM17.8672 26.0608C14.0683 26.0608 11.4239 28.7332 10.9856 32.4599H24.37C24.0318 28.6547 21.3874 26.0608 17.8672 26.0608Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 12,
    r: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3114_2208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 2C37.48 2 33 6.48 33 12C33 17.52 37.48 22 43 22C48.52 22 53 17.52 53 12C53 6.48 48.52 2 43 2ZM40.29 16.29L36.7 12.7C36.31 12.31 36.31 11.68 36.7 11.29C37.09 10.9 37.72 10.9 38.11 11.29L41 14.17L47.88 7.29C48.27 6.9 48.9 6.9 49.29 7.29C49.68 7.68 49.68 8.31 49.29 8.7L41.7 16.29C41.32 16.68 40.68 16.68 40.29 16.29Z",
    fill: "#0178A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3114_2208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(31)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpocratesPlusTickIcon);
export default __webpack_public_path__ + "static/media/epocrates-plus-tick-icon.d1c5bb1466d3f234669dd4d3bec8ebb4.svg";
export { ForwardRef as ReactComponent };